import { useThemeMode } from '@/hooks/useThemeMode';
import { ThemeMode } from '@/providers/ThemeModeContext';
import { DarkMode, LightMode, SettingsBrightness } from '@mui/icons-material';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

export const ThemeModeSelector = () => {
  const { mode, setMode } = useThemeMode();

  const handleChange = (_: React.MouseEvent<HTMLElement>, newMode: ThemeMode | null) => {
    if (newMode) {
      setMode(newMode);
    }
  };

  return (
    <Box sx={{ px: 2, py: 1 }}>
      <Typography variant='body2' sx={{ mb: 1, fontWeight: 500, color: 'text.secondary' }}>
        Appearance
      </Typography>
      <ToggleButtonGroup value={mode} exclusive onChange={handleChange} size='small' fullWidth>
        <ToggleButton value='light' sx={{ textTransform: 'none', gap: 0.5 }}>
          <LightMode sx={{ fontSize: 16 }} />
          Light
        </ToggleButton>
        <ToggleButton value='dark' sx={{ textTransform: 'none', gap: 0.5 }}>
          <DarkMode sx={{ fontSize: 16 }} />
          Dark
        </ToggleButton>
        <ToggleButton value='system' sx={{ textTransform: 'none', gap: 0.5 }}>
          <SettingsBrightness sx={{ fontSize: 16 }} />
          System
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
